/**
 * Default availability for new users
 */
export function getDefaultAvailability() {
  return {
    mon: [
      {
        start: DEFAULT_WORK_START_TIME,
        end: DEFAULT_WORK_END_TIME,
      },
    ],
    tue: [
      {
        start: DEFAULT_WORK_START_TIME,
        end: DEFAULT_WORK_END_TIME,
      },
    ],
    wed: [
      {
        start: DEFAULT_WORK_START_TIME,
        end: DEFAULT_WORK_END_TIME,
      },
    ],
    thu: [
      {
        start: DEFAULT_WORK_START_TIME,
        end: DEFAULT_WORK_END_TIME,
      },
    ],
    fri: [
      {
        start: DEFAULT_WORK_START_TIME,
        end: DEFAULT_WORK_END_TIME,
      },
    ],
    sat: [],
    sun: [],
  };
}

/**
 * Default work start time of the day
 */
export const DEFAULT_WORK_START_TIME = '9:00';

/**
 * Default work end time of the day
 */
export const DEFAULT_WORK_END_TIME = '17:00';
